import { createAction, props } from '@ngrx/store';

export * from './stratalot-association-generated.actions';

export const deleteManyStratalotAssociationSuccess = createAction(
  '[StratalotAssociation] Delete Many Stratalot-Association Success',
  props<{ idStratalotAssociations: number[] }>()
);
